import { createSlice } from "@reduxjs/toolkit";

import {
  addApiCases,
  createDynamicThunk,
} from "../../../../../service/requestHandler";

// --- Thunks ---

export const fetchCoverageSummary = createDynamicThunk(
  "fetchCoverageSummary",
  "/report/api/v1/assetCoverage/summary"
);

export const fetchAssetCoverageFilters = createDynamicThunk(
  "fetchAssetCoverageFilters",
  "/report/api/v1/assetCoverage/filters",
  [],
  "GET"
);

export const fetchAssetsByOS = createDynamicThunk(
  "fetchAssetsByOS",
  "/report/api/v1/assetCoverage/assetsByOperatingSystem"
);

export const fetchAssetsByType = createDynamicThunk(
  "fetchAssetsByType",
  "/report/api/v1/assetCoverage/assetsByType"
);

export const fetchAssetsByEnvironment = createDynamicThunk(
  "fetchAssetsByEnvironment",
  "/report/api/v1/assetCoverage/assetsByEnvironment"
);

export const fetchAssetsNotScanned = createDynamicThunk(
  "fetchAssetsNotScanned",
  "/report/api/v1/assetCoverage/appAssetNotScanned"
);

export const fetchAssetDetailsList = createDynamicThunk(
  "fetchAssetDetailsList",
  "/report/api/v1/assetCoverage/list",
  ["pageNumber", "itemsPerPage"]
);

export const fetchChartDrilldown = createDynamicThunk(
  "fetchChartDrilldown",
  "/report/api/v1/assetCoverage/assets/drilldown",
  ["pageNumber", "itemsPerPage"]
);

export const fetchOpenVulnerabilityDetails = createDynamicThunk(
  "fetchOpenVulnerabilityDetails",
  "/report/api/v1/assetCoverage/openVulnerabilityDetails",
  ["pageNumber", "itemsPerPage"]
);

export const fetchCisOpenVulnerabilityList = createDynamicThunk(
  "fetchCisOpenVulnerabilityList",
  "/report/api/v1/assetCoverage/cisOpenVulnerabilityList",
  ["pageNumber", "itemsPerPage"]
);

// --- Initial State ---

export const initialState = {
  coverageData: null,
  coverageDataLoading: false,
  filterOptionsData: null,
  filterOptionsDataLoading: false,
  assetsByOSData: null,
  assetsByOSDataLoading: false,
  assetsByTypeData: null,
  assetsByTypeDataLoading: false,
  assetsByEnvironmentData: null,
  assetsByEnvironmentDataLoading: false,
  assetsNotScannedData: null,
  assetsNotScannedDataLoading: false,
  assetDetailsListData: null,
  assetDetailsListDataLoading: false,
  chartDrilldownData: null,
  chartDrilldownDataLoading: false,
  openVulnerabilityDetailsData: null,
  openVulnerabilityDetailsDataLoading: false,
  cisOpenVulnerabilityListData: null,
  cisOpenVulnerabilityListDataLoading: false,
  selectedFilters: {},
};

// --- Slice ---

const assetCoverageSlice = createSlice({
  name: "assetCoverageSlice",
  initialState,
  reducers: {
    setSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetAssetCoverageState: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, fetchCoverageSummary, "coverageData");
    addApiCases(builder, fetchAssetCoverageFilters, "filterOptionsData");
    addApiCases(builder, fetchAssetsByOS, "assetsByOSData");
    addApiCases(builder, fetchAssetsByType, "assetsByTypeData");
    addApiCases(builder, fetchAssetsByEnvironment, "assetsByEnvironmentData");
    addApiCases(builder, fetchAssetsNotScanned, "assetsNotScannedData");
    addApiCases(builder, fetchAssetDetailsList, "assetDetailsListData");
    addApiCases(builder, fetchChartDrilldown, "chartDrilldownData");
    addApiCases(builder, fetchOpenVulnerabilityDetails, "openVulnerabilityDetailsData");
    addApiCases(builder, fetchCisOpenVulnerabilityList, "cisOpenVulnerabilityListData");
  },
});

export const { setSelectedFilters, resetAssetCoverageState } =
  assetCoverageSlice.actions;

export default assetCoverageSlice.reducer;
